module.exports = __webpack_public_path__ + "static/media/default-feature.ac12f0ac.svg";